import { prospectTransport } from "@/src/config/prospectTransport.js";

let _filterSearchTimer = null;
let _filterSearchReject = null;
let _leadSearchController = null;
let _companiesSearchController = null;

export default {
  async getProspectFilterOptions(field, search) {
    if (search) {
      if (_filterSearchTimer) {
        clearTimeout(_filterSearchTimer);
        if (_filterSearchReject) {
          _filterSearchReject(new DOMException("Debounced", "AbortError"));
          _filterSearchReject = null;
        }
      }
      return new Promise((resolve, reject) => {
        _filterSearchReject = reject;
        _filterSearchTimer = setTimeout(async () => {
          _filterSearchReject = null;
          try {
            const params = { field, search };
            const res = await prospectTransport.get("/prospect/filters", { params });
            resolve(res.data);
          } catch (error) {
            reject(error);
          }
        }, 300);
      });
    }
    if (_filterSearchTimer) clearTimeout(_filterSearchTimer);
    _filterSearchReject = null;
    const params = {};
    if (field) params.field = field;
    try {
      const res = await prospectTransport.get("/prospect/filters", { params });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async searchLeads(params) {
    if (_leadSearchController) {
      _leadSearchController.abort();
    }
    _leadSearchController = new AbortController();

    try {
      let res = await prospectTransport.post("/leads/search", params, {
        signal: _leadSearchController.signal,
      });
      return res.data;
    } catch (error) {
      if (error.name === "AbortError" || error.name === "CanceledError") {
        return null;
      }
      throw error;
    }
  },

  async searchLeadsCache() {
    try {
      let res = await prospectTransport.get("/leads/cache");
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async searchCompanies(params) {
    if (_companiesSearchController) {
      _companiesSearchController.abort();
    }
    _companiesSearchController = new AbortController();

    try {
      let res = await prospectTransport.post("/companies/search", params, {
        signal: _companiesSearchController.signal,
      });
      return res.data;
    } catch (error) {
      if (error.name === "AbortError" || error.name === "CanceledError") {
        return null;
      }
      throw error;
    }
  },

  async searchCompaniesCache() {
    try {
      let res = await prospectTransport.get("/companies/cache");
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getLeadDetails(id) {
    try {
      let res = await prospectTransport.get(`/leads/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getCompanyDetails(id) {
    try {
      let res = await prospectTransport.get(`/companies/${id}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async aiSearchLeads(params) {
    try {
      let res = await prospectTransport.post("/leads/ai", params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async aiSearchCompanies(params) {
    try {
      let res = await prospectTransport.post("/companies/ai", params);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async enrichProspectLeads(payload) {
    try {
      let res = await prospectTransport.post("/enrich/leads", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async enrichProspectCompanies(payload) {
    try {
      let res = await prospectTransport.post("/enrich/companies", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async enrichCRMEntity(payload) {
    try {
      let res = await prospectTransport.post("/enrich/crm", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async enrichCRMBulk(payload) {
    try {
      let res = await prospectTransport.post("/enrich/crm/bulk", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getEnrichments(params) {
    try {
      let res = await prospectTransport.get("/enrichments", { params });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async updateEnrichmentAction(id, payload) {
    try {
      let res = await prospectTransport.patch(`/enrichments/${id}/action`, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async fetchWaterfallVendors() {
    try {
      let res = await prospectTransport.get("/waterfall/vendors");
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async createWaterfallAccount(payload) {
    try {
      let res = await prospectTransport.post("/waterfall/accounts", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async updateWaterfallAccount(accountId, payload) {
    try {
      let res = await prospectTransport.put(
        `/waterfall/accounts/${accountId}`,
        payload,
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteWaterfallAccount(accountId) {
    try {
      let res = await prospectTransport.delete(
        `/waterfall/accounts/${accountId}`,
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async updateWaterfallConfig(payload) {
    try {
      let res = await prospectTransport.put("/waterfall/config", payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async enrichCSV(formData) {
    try {
      let res = await prospectTransport.post("/enrich/csv", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  async getCSVEnrichments(params) {
    try {
      let res = await prospectTransport.get("/enrich/csv", { params });
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};
